import React from 'react';
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import ContentPanel from "../components/ContentPanel/ContentPanel";
import Skeleton from "../components/Skeleton/Skeleton";

const formAssemblyPatterns = () => {
  return (
    <div className="wrapper">
      <Breadcrumbs/>
      <h1 className="two-three-rows__title">Form Assembly Patterns</h1>
      <div className="iframe-box-wrapper">
        <ContentPanel
          templateUrl="./content/form-assembly-patterns/index.html"
          skeleton={<Skeleton type="IFRAME"/>}
          errorTemplate={<Skeleton type="IFRAME_ERROR"/>}
        />
      </div>
    </div>
  )
};

export default formAssemblyPatterns;



// WEBPACK FOOTER //
// ./src/pages/FormAssemblyPatterns.js